import {PlayersStatisticsCategoriesApiModel} from "./players-statistics.categories.api-model";
import {BaseDomainModel} from "../../../../../infrastructure/models/base-domain-model";

export class PlayersStatisticsCategoriesDomainModel extends BaseDomainModel {
  apiModel: PlayersStatisticsCategoriesApiModel;

  get name(): String {
    return this.apiModel.name;
  }

  get shortName(): String {
    return this.apiModel.shortName;
  }

  get subjectId(): Number {
    return this.apiModel.subjectId;
  }
}